import { createContext } from "react";

/** The workflow being edited, for the parts of the builder that read its saved state from the server (`null`: a read-only version view, which has no such state). */
export const WorkflowIdContext = createContext<string | null>(null);
